<template>
	<div class="search-field">
		<div class="field">
			<div class="control is-medium  has-icons-right">
				<input class="input" :class="inputClass" type="text" :placeholder="placeholder" v-model="searchText" />
				<span class="icon is-small is-right">
					<a class="delete" @click="clear" v-if="searchText"></a>
					<img src="../../assets/svg/search.svg" v-else />
				</span>
			</div>
		</div>
	</div>
</template>
<script>
	import _debounce from 'lodash.debounce'
	export default {
		props: {
			value: {
				type: String,
				default:''
			},
			placeholder: {
				default: '',
				type: String
			},
			inputClass: {
				default: '',
				type: String
			},
			searchDelay: {
				type: Number,
				default: 500
			}
		},
		data() {
			return {
				searchText: this.value
			}
		},
		methods: {
			clear() {
				this.searchText = '';
			}
		},
		watch: {
			searchText() {
				this.debouncedText();
			}
		},
		created() {
			this.debouncedText = _debounce(() => {
				this.$emit('input', this.searchText);
			}, this.searchDelay);
		}
	}
</script>
